module.exports = "/_next/static/resources/array-f9a40baa896102a2fa82e7de88b80736.webp";